import * as Sentry from "@sentry/react";

export const initSentry = () => {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    console.warn("Sentry DSN not provided, skipping Sentry initialization");
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT ||
      import.meta.env.VITE_ENV ||
      "development",
    release: `wbd-prototype@${new Date().toISOString().split("T")[0]}`,

    integrations: [
      // Browser tracing for performance monitoring
      Sentry.browserTracingIntegration(),
      // Session replay (only on errors in production)
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Performance monitoring
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

    // Session replay sampling
    replaysSessionSampleRate: import.meta.env.PROD ? 0 : 0.1, // 0% in production for cost savings
    replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 1.0, // 100% on errors

    // Send default PII (user context)
    sendDefaultPii: import.meta.env.VITE_SENTRY_SEND_DEFAULT_PII,

    // Only send errors in non-local environments
    beforeSend(event, hint) {
      // Always log in development
      if (import.meta.env.DEV) {
        console.log("Sentry event:", event);
        console.log("Error hint:", hint.originalException);
      }

      // Don't send events in local environment
      if (import.meta.env.VITE_ENV === "local") {
        return null;
      }

      // Filter out some common non-critical errors
      const error = hint.originalException;
      if (error && error instanceof Error) {
        // Ignore network errors that might be expected
        if (error.message?.includes("Network request failed")) {
          return null;
        }
      }

      return event;
    },
  });
};
